<template>
  <div>
    <div class="row" style="justify-content: center; margin-bottom: 50px;">
      <div class="col-xs-12">
        <FormIconTags/>
      </div>
    </div>
    <div class="col-md-12 card">
      <div class="card-content row">
        <div class="col-sm-6 col-md-9">
        </div>
        <div class="col-sm-6 col-md-3">
          <p-search @on-search="handleSearch($event)"></p-search>
        </div>
        <div class="col-sm-12">
          <el-table
            class="table-striped"
            :data="eventsSpecifications"
            :default-sort="{prop: 'createdAt', order: 'descending'}"
            v-loading="loading"
            style="width: 100%"
          >

            <el-table-column
              prop="event.reference"
              label="Referência"
              :min-width="150"
            ></el-table-column>
            <el-table-column
              prop="event.city"
              label="Município"
              sortable
            ></el-table-column>
            <el-table-column
              prop="tags"
              label="Tags"
            >
              <template slot-scope="scope">
                <p v-for="(categorie) in Object.keys(scope.row.tags)" class="tag-icon text-center">
                  {{ tagsByCategories[categorie].find(item => item._id === scope.row.tags[categorie]).name }}
                </p>
              </template>
            </el-table-column>
            <el-table-column
              prop="gps"
              label="GPS"
            >
              <template slot-scope="scope">
                Latitude: {{ scope.row.gps.lat }} <br>
                Longitude: {{ scope.row.gps.lng }}
              </template>
            </el-table-column>

            <el-table-column label="Ações">
              <template slot-scope="scope">
                <div>
                  <router-link :to="{name: 'eventsSpecifications.edit', params: {id: scope.row._id}}">
                    <button class="btn btn-fill dropdown-toggle btn-icon">Modificar</button>
                  </router-link>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="col-sm-12 text-center">
          <p-pagination
            v-model="currentPage"
            :per-page="pagination.perPage"
            :total="pagination.total"
          ></p-pagination>
        </div>
      </div>
    </div>
    <div class="col-sm-12 pagination-info text-right">
      <p class="category"> Mostrando de {{from + 1}} até {{to}} de {{total}} no total.</p>
    </div>
  </div>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex'
  import FormIconTags from '../../components/Trg/EventsSpecifications/FormIconTags'

  export default {
    name: 'IndexEventsSpecifications',
    components: {
      FormIconTags
    },
    data () {
      return {
        totalSpecifications: 0,
        search: '',
        currentPage: 1,
        pagination: {
          perPage: 40,
          currentPage: 1,
          total: 0
        }
      }
    },
    watch: {
      currentPage: function (currentPage) {
        if (this.search.length > 0) {
          this.fetchAll({
            'search': {query: this.search, fields: ['event.reference']},
            limit: this.pagination.perPage,
            skip: this.from,
            sort: {
              field: 'createdAt',
              direction: 'desc'
            }
          })
        } else {
          this.fetchAll({
            limit: this.pagination.perPage,
            skip: this.from,
            sort: {
              field: 'createdAt',
              direction: 'desc'
            }
          })
        }
      }
    },
    computed: {
      ...mapGetters('tags', ['tagsByCategories']),
      ...mapGetters('eventsSpecifications', {
        eventsSpecifications: 'eventsSpecifications',
        loading: 'loading'
      }),
      to () {
        let highBound = this.from + this.pagination.perPage
        if (this.total < highBound) {
          highBound = this.total
        }
        return highBound
      },
      from () {
        return this.pagination.perPage * (this.currentPage - 1)
      },
      total () {
        this.pagination.total = this.totalSpecifications
        return this.totalSpecifications
      }
    },
    methods: {
      ...mapActions('eventsSpecifications', ['fetchAll', 'fetchCount']),
      ...mapActions('tags', {fetchTags: 'fetchAll'}),
      handleSearch (e) {
        this.search = e
        this.fetchAll({
          'search': {query: e, fields: ['event.reference']},
          limit: this.pagination.perPage,
          skip: this.from,
          sort: {
            field: 'createdAt',
            direction: 'desc'
          }
        })
        this.fetchCount({
          'search': {query: e, fields: ['event.reference']},
          limit: 99999
        }).then(count => {
          this.totalSpecifications = count
        })
      }
    },
    mounted () {
      this.fetchTags({limit: 8888})
        .then(() => {
          this.fetchAll({
            limit: this.pagination.perPage,
            skip: this.from,
            sort: {
              field: 'createdAt',
              direction: 'desc'
            }
          })
        })
      this.fetchCount({limit: 9999}).then(count => {
        this.totalSpecifications = count
      })
    }
  }
</script>

<style scoped>
  .tag-icon {
    padding-left: 5px;
    padding-right: 5px;
    padding-top: 5px;
    padding-bottom: 5px;
    margin-left: 5px;
    background: #badfe4;
    border-radius: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/EventsSpecifications/IndexEventsSpecifications.vue